import React, { lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Layout from "./Layout";
import Home from "./Home";
import ErrorPage from "./ErrorPage";
import CustomizationTShirtPage from "./CustomizationTShirtPage";
import BannerShimmer from "./BannerShimmer";

// ---------- LAZY PAGES ----------
const Men = lazy(() => import("./Men"));
const Women = lazy(() => import("./Women"));
const Kids = lazy(() => import("./Kids"));
const Cart = lazy(() => import("./Cart"));
const Contact = lazy(() => import("./Contact"));
const Checkout = lazy(() => import("./Checkout"));
const CheckoutWhatsApp = lazy(() => import("./CheckoutWhatsApp"));

const CoupleCard = lazy(() => import("./CoupleCard"));
const CoupleProductDetails = lazy(() => import("./CoupleProductDetails"));

const SuccessPage = lazy(() => import("./SuccessPage"));
const MensProductDetails = lazy(() => import("./MensProductDetails"));
const MyOrders = lazy(() => import("./MyOrders"));

// ---------- Loging/SignIn PAGES ----------
const Login = lazy(() => import("../auth/Login"));
const Signup = lazy(() => import("../auth/Signup"));

// ---------- ADMIN PAGES ----------
const AdminLogin = lazy(() => import("../Pages/AdminLogin"));
const AdminDashboard = lazy(() => import("../Pages/AdminDashboard"));
const AdminOrders = lazy(() => import("../Pages/AdminOrders"));
const AdminCustomers = lazy(() => import("../Pages/AdminCustomers"));
const AdminInventory = lazy(() => import("../Pages/AdminInventory"));

/* ✅ ROUTER MUST BE OUTSIDE COMPONENT */
const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Home /> },

      {
        path: "men",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <Men />
          </Suspense>
        ),
      },
      {
        path: "login",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <Login />
          </Suspense>
        ),
      },
      {
        path: "signup",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <Signup />
          </Suspense>
        ),
      },
      {
        path: "women",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <Women />
          </Suspense>
        ),
      },
      {
        path: "couple",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <CoupleCard />
          </Suspense>
        ),
      },
      {
        path: "couple/:id",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <CoupleProductDetails />
          </Suspense>
        ),
      },

      {
        path: "kids",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <Kids />
          </Suspense>
        ),
      },
      {
        path: "product/:id",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <MensProductDetails />
          </Suspense>
        ),
      },
      {
        path: "customize",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <CustomizationTShirtPage />
          </Suspense>
        ),
      },
      {
        path: "cart",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <Cart />
          </Suspense>
        ),
      },
      {
        path: "checkout",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <Checkout />
          </Suspense>
        ),
      },
      {
        path: "success",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <SuccessPage />
          </Suspense>
        ),
      },
      {
        path: "orders",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <MyOrders />
          </Suspense>
        ),
      },
      {
        path: "contact",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <Contact />
          </Suspense>
        ),
      },

      // ---------- ADMIN ----------
      {
        path: "admin/login",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <AdminLogin />
          </Suspense>
        ),
      },
      {
        path: "admin/dashboard",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <AdminDashboard />
          </Suspense>
        ),
      },
      {
        path: "admin/orders",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <AdminOrders />
          </Suspense>
        ),
      },
      {
        path: "admin/customers",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <AdminCustomers />
          </Suspense>
        ),
      },
      {
        path: "admin/inventory",
        element: (
          <Suspense fallback={<BannerShimmer />}>
            <AdminInventory />
          </Suspense>
        ),
      },
    ],
  },
]);

/* ✅ CLEAN COMPONENT */
export default function Body() {
  return <RouterProvider router={router} />;
}
